import AbstractApi from '@/api/abstracts/AbstractApi'
import SpecificationsApi from '@/api/services/sales/bid/spec/SpecificationsApi'
import CostingsApi from '@/api/services/sales/bid/cost/CostingsApi'
import EquipmentsApi from './equipments/EquipmentsApi'
import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { BidRegisterType, CreateBidType } from '@/api/types/response/BidRegisterType'
import type { BidAuthorityType } from '@/api/types/response/BidAuthorityType'
import type { CreateBidPayloadType } from '@/api/types/request/CreateBidPayloadType'
import type { BidNumber } from '@/api/types/general/GeneralType'

/**
 * @property string apiEnd /api/sales/bid
 */
export default class BidApi extends AbstractApi {
  registerSettings(): Promise<BidRegisterType> {
    return httpClient.get(`${this.apiEnd}/registers`)
  }

  authority(payload: string): Promise<BidAuthorityType> {
    return httpClient.get(`${this.apiEnd}/authority/${payload}`)
  }

  add(payload: CreateBidPayloadType): Promise<CreateBidType> {
    return httpClient.post(`${this.apiEnd}/registers`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  spec(): SpecificationsApi {
    return new SpecificationsApi(`${this.apiEnd}/spec`)
  }

  costings(): CostingsApi {
    return new CostingsApi(`${this.apiEnd}/cost`)
  }

  equipments(bidNumber: BidNumber): EquipmentsApi {
    return new EquipmentsApi(`${this.apiEnd}/equipments/${bidNumber}`)
  }
}
